export const ChecklastClick = (
  func: any,
  lastClick: number,
  setlastClick: any
) => {
  var timeNow = new Date().getTime();
  timeNow > lastClick + 1816 ? func(false) : func(true);
  setlastClick(timeNow);
};
